import { HYDRATE } from 'next-redux-wrapper';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum DestinationActions {
  SLICE_NAME = '@APP/DESTINATION',
  SET_DESTINATION = '@APP/DESTINATION/setDestination'
}

export const INITIAL_DESTINATION_STATE: string = '';

const destinationSlice = createSlice({
  name: DestinationActions.SLICE_NAME,
  initialState: INITIAL_DESTINATION_STATE,
  reducers: {
    setDestination: (state, action: PayloadAction<string>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state: string = INITIAL_DESTINATION_STATE, action: any) => {
      if (action.payload?.app?.destination !== state) {
        return action.payload?.app?.destination || state;
      }
      return state;
    });
  }
});

export const { setDestination } = destinationSlice.actions;
export const destinationReducer = destinationSlice.reducer;
